import { render, staticRenderFns } from "./OffersStatistics.vue?vue&type=template&id=2ffb6b87&"
import script from "./OffersStatistics.vue?vue&type=script&lang=js&"
export * from "./OffersStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports